import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import Common from '../../utilities/common';
import { PieChart } from '@mui/x-charts/PieChart';
import ReactInterval from 'react-interval';

export interface IIpsByComunidadAutomonaChartState {
    data: any[];
}

export default class IpsByComunidadAutomonaChart extends React.Component<{}, IIpsByComunidadAutomonaChartState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: []
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            IPs por comunidad autónoma
                        </Typography>
                    </Box>
                    {
                        this.state.data.length > 0 && (
                            <PieChart
                                height={450}
                                margin={{
                                    left: 100,
                                    right: 100,
                                    bottom: 250,
                                    top: 100
                                }}
                                series={[
                                    { 
                                        data: this.state.data,
                                        innerRadius: 90,
                                        outerRadius: 140,
                                        highlightScope: { faded: 'global', highlighted: 'item' },
                                        faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' }
                                    }
                                ]}
                                slotProps={
                                    {
                                        legend: {
                                            direction: 'row',
                                            position: {
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                            },
                                            itemMarkWidth: 20,
                                            itemMarkHeight: 12,
                                            markGap: 5,
                                            itemGap: 10,
                                            labelStyle: {
                                                fontSize: 11
                                            }
                                        }
                                    }
                                }
                            />
                        )
                    }
                    {
                        this.state.data.length == 0 && (
                            <div className="textCenter" style={{margin: '20px 0px'}}>
                                <CircularProgress/>
                            </div>
                        )
                    }
                </CardContent>
            </Card>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/masters/ip/total/bycomunidad`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.id = i;
                dataItem.value = response[i].total;
                dataItem.label = response[i].name;

                data.push(dataItem);
            }

            const dataWithColors = Common.SetColors(data);

            this.setState(
                {
                    data: dataWithColors
                }
            );
        })
    }
}